import { ref, computed } from 'vue';
import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import permissionUtils from '@utils/permission.utils';
import { PermissionsDict } from '@models/account/useAccountInfo';

export enum PermissionsStatus {
    OFF = -1, //功能下线，所有人都不会看到
    TEST = 0, //灰度上线，有对应权限才能看到
    ON = 1 //功能上线，所有人都可以看到
}

export interface OriginPermission {
    permissionDict: PermissionsDict[];
    permissionIdList: string[];
}

const GET_PERMISSION_QUERY = gql`
    query getProfilePermission {
        getProfilePermission {
            permissionDict {
                updateTime
                description
                id
                name
                status
            }
            permissionIdList
        }
    }
`;

const permissions = ref<OriginPermission | undefined>();

const hasExperienceV4Permission = computed(() => {
    return checkPermission('experienceV4');
});

const hasExperienceAdvancePermission = computed(() => {
    return checkPermission('enableAdvance');
});

const hasHomePermission = computed(() => {
    return checkPermission('enableHomeV2');
});

export function usePermission() {
    const getPermission = (
        resultCallback?: (T: OriginPermission) => void,
        rejectCallback?: (err: any) => void
    ) => {
        const { onResult, onError } = useQuery<{ getProfilePermission: OriginPermission }>(
            GET_PERMISSION_QUERY,
            {},
            {
                fetchPolicy: 'no-cache'
            }
        );

        onResult(data => {
            if (data.data?.getProfilePermission) {
                permissions.value = data.data?.getProfilePermission;

                // 执行回调
                resultCallback &&
                    typeof resultCallback === 'function' &&
                    resultCallback(permissions.value);
            }
        });

        onError(err => {
            permissions.value = undefined;
            rejectCallback && typeof rejectCallback === 'function' && rejectCallback(err);
        });
    };

    return {
        permissions,
        hasExperienceV4Permission,
        hasExperienceAdvancePermission,
        hasHomePermission,

        getPermission
    };
}

export function checkPermission(permissionName: string) {
    if (!permissions.value) return false;
    return permissionUtils.includePermissionWithAccountInfo([permissionName], {
        permissionIdList: permissions.value.permissionIdList,
        permissionDict: permissions.value.permissionDict
    });
}
